<template>
  <div>
    <div class="login__container">
      <form action="" class="login__container__form" @submit.prevent="auth">
        <div class="login__container__form--header">
          telenor | satellite
        </div>
        <div class="login__container__form--row">
          <label for="username">Username:</label>
          <input type="text" name="username" v-model="username" required>
        </div>
        <div class="login__container__form--row">
          <label for="password">Password:</label>
          <input type="password" name="password" v-model="password" @keyup.enter="auth">
        </div>
        <div class="login__container__form--footer">
          <div class="btn btn-login" @click="auth">
            <span v-if="!loginInProgress">Login</span>
            <span class="lds-dual-ring" v-else></span>
          </div>
          <div class="btn btn-forgot" @click="forgotAction">Forgot?</div>
        </div>
        <div class="login__container__form--error" v-show="formError || loginError">
          Somethings wrong with the login. Please contact admin. 
        </div>
      </form>
    </div>
  </div>
</template>

<script>



export default {
  name: 'Login',
  data(){
    return {
      username: '',
      password: '',
      formError: false,
      // loginInProgress: true
    }
  },
  methods: {
    auth(){
      if(!this.loginInProgress){
        let authDetails = { 'Username': this.username, 'Password': this.password}
        this.$store.dispatch('authenticate', authDetails);
        this.password = '';
      }
    },
    forgotAction(){
      this.formError = true;
    },
  },
  beforeMount() {
    if(this.$route.query.cfe){
      let feedback = this.$route.query.cfe.split("|")
      this.$store.dispatch('addInfoItem', {'type': 'error', 'msg': feedback.join(" ")})
    }
  },
  computed:{
    loginError(){
      return this.$store.getters.loginError;
    },
    loginInProgress(){
      return this.$store.getters.loginInProgress;
    }
  },
}
</script>

<style scoped lang="scss">

  .login__container{
    &__form{
      width: 80%;
      @media only screen and (min-width: $bp-medium) {
        width: 480px;
      }
      margin: 2rem auto;
      
      &--header{
        font-size: 2.6rem;
        margin: 1.6rem auto;
        text-align: center;
      }

      &--row{
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 1rem auto;
        
        & > label{
          margin-bottom: .5rem;
        }

        & > input{
          font-size: 2rem;
          padding: 0 .5rem;
          height: 4.8rem;
          
          background-color: $telenor-light-grey-1;
          border: .1rem solid $telenor-light-grey-1;
          border-radius: .5rem;

          &:focus{
            outline: none;
            border: .1rem solid $telenor-blue;
            border-radius: .5rem;
          }
          &:-webkit-autofill{
            background-color: $telenor-light-grey-1;
          }
        }
      }

      &--footer{
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .btn{
          display: block;
          height: 4.8rem;
          line-height: 4.8rem;

          border: .1rem solid black;
          border-radius: .5rem;

          text-decoration: none;
          color: $telenor-black;

          padding-left: 1.6rem;
          padding-right: 1.6rem;

          font-size: 1.6rem;
        }

        .btn-login{
          background-color: $telenor-link;
          border-color: $telenor-link;
          color: $telenor-white;
        }
        .btn-forgot{
          background-color: $telenor-white;
          border-color: $telenor-black;
          // color: $telenor-white;
        }

      }

      &--error{
        background-color: $telenor-info-red;
        margin-top: 1rem;
        padding: .5rem;
        font-size: 1.2rem;
        border-radius: .5rem;
      }
    }
  }
</style>